import { gql } from '@apollo/client';
import { NamedFilterFragment } from '../filters';
import { ErrorFragment } from '../fragments';
import { VirtualEventFragment } from './fragments';

export const CREATE_VIRTUAL_EVENT = gql`
  mutation CreateVirtualEvent($input: VirtualEventCreateInput!) {
    virtualEventCreate(input: $input) {
      entity {
        ...VirtualEventFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${VirtualEventFragment}
  ${ErrorFragment}
`;

export const UPDATE_VIRTUAL_EVENT = gql`
  mutation UpdateVirtualEvent($input: VirtualEventEditInput!) {
    virtualEventEdit(input: $input) {
      entity {
        ...VirtualEventFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${VirtualEventFragment}
  ${ErrorFragment}
`;

export const VIRTUAL_EVENT_ADD_CATEGORY = gql`
  mutation VirtualEventAddCategory($input: NamedEntityEditCategoryInput!) {
    virtualEventAddCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const VIRTUAL_EVENT_REMOVE_CATEGORY = gql`
  mutation VirtualEventRemoveCategory($input: NamedEntityEditCategoryInput!) {
    virtualEventRemoveCategory(input: $input) {
      message
      errors {
        ...ErrorFields
      }
    }
  }
  ${ErrorFragment}
`;

export const CREATE_NAMED_FILTER = gql`
  mutation CreateNamedFilter($input: NamedFilterCreateInput!) {
    namedFilterCreate(input: $input) {
      entity {
        ...NamedFilterFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${NamedFilterFragment}
  ${ErrorFragment}
`;

export const UPDATE_NAMED_FILTER = gql`
  mutation UpdateNamedFilter($input: NamedFilterEditInput!) {
    namedFilterEdit(input: $input) {
      entity {
        ...NamedFilterFields
      }
      errors {
        ...ErrorFields
      }
    }
  }
  ${NamedFilterFragment}
  ${ErrorFragment}
`;
